import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Container, Divider, Menu, Segment } from 'semantic-ui-react';

interface Props {
  children: any;
  appName: string;
  accountId?: string;
  inverted?: boolean;
  onNavigateHome: () => void;
  onNavigateContests: () => void;
  onNavigateRanking: () => void;
  onNavigateProfile?: () => void;
  onLogout?: () => void;
  onNavigateContact: () => void;
}

const PageWrapper: React.FC<Props> = ({
  children,
  appName,
  accountId,
  inverted = true,
  onNavigateHome,
  onNavigateContests,
  onNavigateRanking,
  onNavigateProfile,
  onLogout,
  onNavigateContact,
}) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
      }}
    >
      <Menu fixed="top" inverted={inverted} style={{ overflow: 'auto' }}>
        <Menu.Item header={true} onClick={onNavigateHome}>
          {appName}
        </Menu.Item>
        <Menu.Item onClick={onNavigateContests}>Contests</Menu.Item>
        <Menu.Item onClick={onNavigateRanking}>Ranking</Menu.Item>
        {accountId && (
          <>
            <Menu.Item position="right" onClick={onNavigateProfile}>
              Profile
            </Menu.Item>
            <Menu.Item onClick={onLogout}>Logout</Menu.Item>
          </>
        )}
      </Menu>
      <Container text={true} style={{ marginTop: '6em', flex: 1 }}>
        {children}
      </Container>
      <div style={{ height: '5em' }} />
      <Segment inverted={inverted} vertical={true} style={{ padding: '2em 0em' }}>
        <Container textAlign="center">
          <Button basic={true} inverted={inverted} onClick={onNavigateContact}>
            Contact Me
          </Button>
          <Divider inverted={inverted} />
          <p>Copyright © 2019 sono. All rights reserved.</p>
        </Container>
      </Segment>
    </div>
  );
};

export default PageWrapper;
